export default "/assets/images/rocket.png?c7d266c0b986dbd0b2d2a9e696c81d3b";